import React from 'react';
import ReactPaginate from 'react-paginate';

const CustomPagination = ({
  currentPage,
  handlePagination,
  pageCount,
}) => {
  return (
    <ReactPaginate
      previousLabel={<span>Anterior</span>}
      nextLabel={<span>Siguiente</span>}
      forcePage={currentPage}
      onPageChange={handlePagination}
      pageCount={pageCount}
      breakLabel={'...'}
      pageRangeDisplayed={2}
      marginPagesDisplayed={2}
      activeClassName={'active'}
      pageClassName={'page-item'}
      nextLinkClassName={'page-link'}
      nextClassName={'page-item next'}
      previousClassName={'page-item prev'}
      previousLinkClassName={'page-link'}
      pageLinkClassName={'page-link'}
      breakClassName='page-item'
      breakLinkClassName='page-link'
      containerClassName={
        'pagination react-paginate pagination-sm justify-content-end pe-1 mt-1'
      }
    />
  );
};

export default CustomPagination;
